
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import PageLoadingSpinner from '@/components/common/PageLoadingSpinner';
import {
  LazyRentalCalendar,
  LazyRentalKits,
  LazyRentalDenials,
  LazyCrossLocationRental,
  LazyWorkshop
} from './lazyRoutes';

const withSuspense = (
  Component: React.LazyExoticComponent<React.ComponentType<Record<string, never>>>,
  fallbackMessage?: string
): JSX.Element => {
  return (
    <Suspense fallback={<PageLoadingSpinner message={fallbackMessage} />}>
      <Component />
    </Suspense>
  );
};

export const getRentalRoutes = () => [
  <Route key="rental-calendar" path="/rental-calendar" element={
    <ProtectedRoute>
      {withSuspense(LazyRentalCalendar, "Загрузка календаря аренды...")}
    </ProtectedRoute>
  } />,
  <Route key="rental-kits" path="/rental-kits" element={
    <ProtectedRoute>
      {withSuspense(LazyRentalKits, "Загрузка комплектов аренды...")}
    </ProtectedRoute>
  } />,
  <Route key="rental-denials" path="/rental-denials" element={
    <ProtectedRoute>
      {withSuspense(LazyRentalDenials, "Загрузка отказов аренды...")}
    </ProtectedRoute>
  } />,
  <Route key="cross-location" path="/cross-location" element={
    <ProtectedRoute>
      {withSuspense(LazyCrossLocationRental, "Загрузка кросс-локационной аренды...")}
    </ProtectedRoute>
  } />,
  <Route key="workshop" path="/workshop" element={
    <ProtectedRoute>
      {withSuspense(LazyWorkshop, "Загрузка мастерской...")}
    </ProtectedRoute>
  } />
];
